import EventsApi from '../api/EventsApi';
import EventsConstants from '../constants/EventsConstants';

function searchEvents(query = {}) {
  return {
    query,
    types: [
      EventsConstants.SEARCH_EVENTS_REQUEST,
      EventsConstants.SEARCH_EVENTS_SUCCESS,
      EventsConstants.SEARCH_EVENTS_FAILURE
    ],
    apiRequest: (state, client) => EventsApi.searchEvents({ ...query, limit: 10 }, client)
  };
}

export default {
  searchEvents
};
